import type { Promotion, ShopPromotion } from '../Promotions.types'

export const isShopPromotion = (promotion: Promotion): promotion is ShopPromotion =>
  promotion.type === 'SINGLE' || promotion.type === 'MULTI' || promotion.type === 'AUTO_APPLYING'
